module.exports = __webpack_public_path__ + "static/media/bg01.5a3cf091.png";